/**
 * Billing setup for Falcon using @roselabs-io/saas-shell
 *
 * This configures the BillingProvider for Falcon's specific needs.
 */

import { createBillingProvider, useBilling } from '@roselabs-io/saas-shell'
import type {
  BillingStatus,
  BillingRestriction,
  BillingContextType,
  PlanResponse,
  SubscriptionResponse,
  UsageResponse,
} from '@roselabs-io/saas-shell'
import apiClient from '../api/client'

const FALCON_API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8003'

// Create billing provider configured for Falcon
export const { BillingProvider, billingApi } = createBillingProvider(apiClient, {
  productApiUrl: FALCON_API_URL,
  gracePeriodDays: 14,
})

// Re-export types and hooks from saas-shell for convenience
export { useBilling }
export type {
  BillingStatus,
  BillingRestriction,
  BillingContextType,
  PlanResponse,
  SubscriptionResponse,
  UsageResponse,
}
